// authIntent — F8.7b · UX intent preservation across signup/login flows.
//
// Use case: unauthenticated user clicks "Buy Starter" on PricingLive. We
// stash the intent in localStorage, open the AuthModal, and after
// verify+login the AuthCallbackHandler pops the intent and triggers the
// intended action (e.g. checkout).
//
// TTL: 30 minutes. Older intents are silently dropped.

const KEY = "glms_auth_intent";
const TTL_MS = 30 * 60 * 1000;

export function setAuthIntent(intent) {
    if (typeof window === "undefined") return;
    try {
        const payload = { ...intent, ts: Date.now() };
        window.localStorage.setItem(KEY, JSON.stringify(payload));
    } catch { /* quota / SSR */ }
}

export function getAuthIntent() {
    if (typeof window === "undefined") return null;
    try {
        const raw = window.localStorage.getItem(KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed?.ts || Date.now() - parsed.ts > TTL_MS) {
            window.localStorage.removeItem(KEY);
            return null;
        }
        return parsed;
    } catch { return null; }
}

export function clearAuthIntent() {
    if (typeof window === "undefined") return;
    try { window.localStorage.removeItem(KEY); } catch { /* noop */ }
}
